<template>
  <one-page-navigation
    class="content-index-header"
    :offset-basis="-70"
    :hide-on-mobile="false"
    :modify-url="false"
    ref="rootEl"
  />
</template>

<script setup lang="ts">
  import {ref, onMounted, useTemplateRef} from 'vue'
  import OnePageNavigation from '../onePageNavigation/onePageNavigation.vue';

  const props = withDefaults(defineProps<{
    sectionIdPrefix?: string,
  }>(), {
    sectionIdPrefix: 'content-index__',
  });

  const rootEl = useTemplateRef<OnePageNavigation>('rootEl');
  const navigationData = ref<{key: string, id: string}[]>([]);

  onMounted(() => {
    const teaserNode = rootEl.value.$el.closest('.content-index');
    const entryNodes = Array.prototype.slice.call(teaserNode.querySelectorAll('.content-index__head'));

    entryNodes.forEach((entry: HTMLElement) => {
      const text = entry.innerText.replace(/\r?\n|\r|\s/g, '');
      const id = props.sectionIdPrefix + text;
      const hasContent = document.getElementById(id).childNodes.length;
      navigationData.value.push({
        key: text,
        id: hasContent ? id : ''
      });
    });
  });
</script>
